import { useFlowDailyMetrics } from 'new/stores/metrics/metrics.api';
import type { DailyMetrics, FlowDailyMetricsParams } from 'new/stores/metrics/metrics.endpoints';

interface FlowDailyMetricsRepositoryHookReturn {
  data: DailyMetrics | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: unknown;
  refetch: () => void;
}

export default function useFlowDailyMetricsRepository(
  originNodeId: number | string | null | undefined,
  params: FlowDailyMetricsParams,
): FlowDailyMetricsRepositoryHookReturn {
  const skip = originNodeId == null;

  const result = useFlowDailyMetrics(originNodeId ?? 0, params, { skip });

  return {
    data: result.data as DailyMetrics | undefined,
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    error: result.error,
    refetch: result.refetch,
  };
}

export { useFlowDailyMetricsRepository };
